module.exports = __webpack_public_path__ + "img/weatherpedia-pwa3.d158861c.png";